import {
  ItemDetailsContentSectionResp,
  ItemDetailsDto,
  ItemDetailsTopSectionResp,
} from '@marketplace-web/item-page/item-page-data'

export const getItemPageReportButtonPluginModel = (itemDto: ItemDetailsDto) => ({
  itemId: itemDto.id,
  ownerId: itemDto.user.id,
  isItemSold: itemDto.item_closing_action === 'sold',
})

export const getServerItemPageReportButtonPluginModel = (
  contentDto: ItemDetailsContentSectionResp | ItemDetailsTopSectionResp,
) => ({
  itemId: contentDto.id,
  ownerId: contentDto.seller_id,
  isItemSold: contentDto.item_closing_action === 'sold',
})
